module.exports = __webpack_public_path__ + "img/murloc_hut_small.815d260e.png";